var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "products-errors-view"
  }, [(_vm.productImports) ? _c('div', _vm._l((_vm.productImports.entries), function(entry) {
    return _c('dl', {
      key: entry.origin
    }, [_c('dd', [_vm._v("Provider")]), _vm._v(" "), _c('dt', [_vm._v(_vm._s(entry.origin))]), _vm._v(" "), _c('dd', [_vm._v("File:")]), _vm._v(" "), _c('dt', [_c('router-link', {
      attrs: {
        "to": {
          name: 'import-report',
          params: {
            id: entry.importId
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(entry.fileName) + "\n        ")])], 1), _vm._v(" "), _c('dd', [_vm._v("Rohdaten:")]), _vm._v(" "), _c('dt', {
      staticClass: "preformatted"
    }, [_vm._v(_vm._s(_vm.prettify(entry.source)))])])
  })) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7907c12","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Products/ImportsView.vue
// module id = 2099
// module chunks = 0